module.exports = __webpack_public_path__ + "9ef1cdca4c6c4a8522a644783aaa32b9.MP3";